// @flow strict
const handleSelectTrip = (language: string, id: string) => {
  window.location.href = `/${language}/account/bookings/${id}`
}

export default handleSelectTrip
